var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-Kapitel';
                    var viewUrl = 'gfx/sprite.svg#view-icon-Kapitel';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 32 25',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };